export function isGradientColor(color: string) {
  const gradientRegex = /^(linear-gradient|radial-gradient)\s*\(/;
  return gradientRegex.test(color.trim());
}
